/**
 * Side navigation on mobile is executed if screen width <= 1193px
 */
export const SIDE_NAVIGATION_ON_MOBILE_BREAKPOINT = 1280;
